import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import { Redirect, Link } from "react-router-dom";
import httpService from "../../../services/httpServices/httpServices";
import MobileHelper from "../../../helpers/mobile";
import helperNumber from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";

function AllNotificationTicket() {
  const [tagAllNotificationTicket, setAllNotificationTicket] = useState();

  useEffect(() => {
    getAllNotificationTicket();
  }, []);

  const getAllNotificationTicket = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allNotificationTicket = await getRequestAllNotificationTicket();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setAllNotificationTicket(
      generateTagAllNotificationTicket(allNotificationTicket)
    );
  };

  const getRequestAllNotificationTicket = async () => {
    const headersRequest = getHeaderForRequset();
    let allNotificationTicket;
    try {
      allNotificationTicket = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/ticket/notification",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return;
    }

    return allNotificationTicket.data.data;
  };

  const generateTagAllNotificationTicket = (allNotificationsTicket) => {
    let tagAllNotificationTicket;
    tagAllNotificationTicket = allNotificationsTicket.map(
      (notificationsTicket, index) => {
        return (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{notificationsTicket.not_id}</td>
            <td>{notificationsTicket.not_name}</td>
            <td dir="ltr">
              {helperNumber.toPersianNum(
                MobileHelper.formatMobile(notificationsTicket.not_mobile)
              )}
            </td>
            <td>
              <span>
                <span
                  className="btn btn-outline-danger  btn-danger"
                  onClick={() =>
                    deleteNotificationTicket(notificationsTicket.not_id)
                  }
                >
                  <i className="fa fa-trash"></i>
                </span>
              </span>
            </td>
          </tr>
        );
      }
    );

    return tagAllNotificationTicket;
  };

  const getHeaderForRequset = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const deleteNotificationTicket = async (notificationTicketID) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (await sendRequestDeleteNotificationTicket(notificationTicketID)) {
      getAllNotificationTicket();
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestDeleteNotificationTicket = async (notificationTicketID) => {
    const headersRequest = getHeaderForRequset();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/ticket/notification/" +
          notificationTicketID,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  return (
    <>
      <Sidebar openItem="manage-tickets" activeItem="all-notification-ticket" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">اطلاع رسانی های تیکت</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="pb-3">
                <Link
                  to="/ticket/add-notification"
                  className="btn btn-outline-info"
                >
                  <span className="pl-2">
                    <i className="fa fa-plus"></i>
                  </span>
                  <span>اطلاع رسانی جدید</span>
                </Link>
              </div>
              <div className="table-responsive">
                <table className="table table-hilite tbl-td-white-space ">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره اطلاع رسانی</td>
                      <td>نام گیرنده</td>
                      <td>شماره موبایل</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>

                  <tbody>{tagAllNotificationTicket}</tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllNotificationTicket;
